import { string, array } from "yup"
import {
  createIntl,
  createIntlCache,
  FormattedMessage as Message,
} from "react-intl"
import isArray from "lodash/isArray"
import isString from "lodash/isString"
import replace from "lodash/replace"
import { isEmail } from "validator"
import message from "./messages"

const intl = createIntl({}, createIntlCache())

export const requiredYup = (
  required = false,
  yupType = string(),
  type = "normal",
) => {
  if (required) {
    let errorMessage = message.required
    return yupType.required(<Message {...errorMessage} />)
  }
  return yupType
}

export const validateEmail = (required = true) => {
  const validate = string()
    .email(<Message {...message.invalidEmail} />)
    .max(255, getFormatMessage(message.maxChar, { max: 255 }))
  return requiredYup(required, validate)
}

export const validateLength = (required = true, min = 2, max = 35) => {
  const validate = string()
    .min(min, getFormatMessage(message.minChar, { min }))
    .max(max, getFormatMessage(message.maxChar, { max }))
  return requiredYup(required, validate)
}

export const getFormatMessage = (messageDescriptor, value) => (
  <Message
    {...messageDescriptor}
    defaultMessage={intl.formatMessage(messageDescriptor, value)}
  />
)

export const validateDuplicateValues = (values) => {
  if (Array.isArray(values) && values.length > 0)
    return new Set(values).size === values.length
  return true
}

export const validateRequestReportEmail = (required = true) => {
  const validate = array()
    .of(
      string().test({
        name: "validateEmailFormat",
        message: <Message {...message.invalidEmail} />,
        test: (value) => isEmail(value.trim()),
      }),
    )
    .min(1, <Message {...message.required} />)
    .test({
      name: "duplicateEmails",
      message: <Message {...message.duplicateEmails} />,
      test: (values) => validateDuplicateValues(values),
    })
  return requiredYup(required, validate)
}

export const removeSpaceCommaFromArray = (array) => {
  if (!isArray(array)) return array
  return array.map((string) => removeSpaceCommaFromString(string))
}

export const removeSpaceCommaFromString = (string) => {
  if (!isString(string)) return string
  return replace(string, /\s+|,+/g, "")
}
